angular.module('dialogs')
    .controller('EventInfoDialogCtrl',
        [
            '$scope', '$modalInstance', '$routeParams', 'EventFactory', 'sportCode',
            function ($scope, $modalInstance, $routeParams, eventFactory, sportCode) {

                init();

                function init() {
                    $scope.SportCode = sportCode === "49" ? "49" : "Irish Lottery";
                    eventFactory.GetEventExtraInfo($routeParams.eventId, 0)
                        .success(function (data) {
                            $scope.EventExtraInfo = data;
                            $scope.SelectedBallSet = parseInt(data.SetOfBalls);
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };

                $scope.Save = function () {
                    eventFactory.SaveEventExtraInfo($routeParams.eventId, $scope.EventExtraInfo)
                        .success(function () {
                            $modalInstance.close('yes');
                            $.message(MessageText.EventExtraInfoSuccessfullySaved, MessageType.Success);
                        })
                        .error(function (error) {
                            $modalInstance.close('yes');
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };

                $scope.no = function () {
                    $modalInstance.dismiss('no');
                };

                $scope.Cancel = function () {
                    $modalInstance.close('yes');
                };

                $scope.UpdateBallSet = function (selectedBallSet) {
                    eventFactory.GetEventExtraInfo($routeParams.eventId, parseInt(selectedBallSet))
                        .success(function (data) {
                            $scope.EventExtraInfo = data;
                            $scope.SelectedBallSet = selectedBallSet;
                        })
                        .error(function (error) {
                            $.message(error.ExceptionMessage, MessageType.Error);
                        });
                };
            }
        ]);